export default "__VITE_ASSET__VfL_CNb7__"